import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1272d102&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=1272d102&prod&lang=less"
import style1 from "./Home.vue?vue&type=style&index=1&id=1272d102&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272d102",
  null
  
)

export default component.exports